import { render, staticRenderFns } from "./PercentBar.vue?vue&type=template&id=a06d0188&scoped=true"
import script from "./PercentBar.vue?vue&type=script&lang=js"
export * from "./PercentBar.vue?vue&type=script&lang=js"
import style0 from "./PercentBar.vue?vue&type=style&index=0&id=a06d0188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06d0188",
  null
  
)

export default component.exports